import type { Note } from '@/types/note';
import { useDeleteNote, useUpdateNote } from '@/features/notes/hooks/use-note-mutations';
import { confirmDialog, promptDialog } from '@/utils/dialog';
import { useCallback } from 'react';

export function useMenuItemNoteActions() {
  const deleteNoteMutation = useDeleteNote();
  const updateNoteMutation = useUpdateNote();

  const handleDeleteNote = useCallback(
    (note: Note) => {
      confirmDialog(
        'Delete Note',
        'Are you sure you want to delete this note? This cannot be undone.',
        () => deleteNoteMutation.mutate(note.id),
      );
    },
    [deleteNoteMutation],
  );

  const handleEditNote = useCallback(
    (note: Note) => {
      promptDialog(
        'Edit Note',
        'Update your tasting note:',
        note.content,
        (text: string) => {
          updateNoteMutation.mutate({ id: note.id, data: { content: text } });
        },
        'To edit this note, open it from the Notes tab on your profile.',
      );
    },
    [updateNoteMutation],
  );

  return { handleDeleteNote, handleEditNote };
}
